module.exports = __webpack_public_path__ + "media/new/profile-modal-check-74090bb7.svg";